import React, { Component } from "react";
import { Link } from "react-router-dom";
import { StatusData } from "../../shared/types";
import BlockCalculator from "../../utils/Calculators/InformationCalculator";
import ContentArea from "../ContentArea/ContentArea";
import CycleProgressHybrid from "../CycleProgress/CycleProgressHybrid";
import EmissionGauge from "../EmissionGauge/EmissionGauge";
import FearAndGreedGauge from "../FearAndGreedGauge/FearAndGreedGauge";
import "./Style.css";

const TERA = 10 ** 12;
const ZETTA = 10 ** 21;

type Props = {
  status: StatusData;
};

class StatsArea extends Component<Props> {

  private renderPlaceholder() {
    return (
      <div className="stats-shell">
        Stats content is in progress. Stay tuned...
      </div>
    );
  }

  private renderStats() {
    const { network, fearAndGreed, mining } = this.props.status;
    const { currentBlock } = network;
    const { value: score, hundredDayAverage, yearAverage } = fearAndGreed;
    const { hashrate, difficulty } = mining;
    const networkAgeYears = BlockCalculator.calculateNetworkAgeInYears();
    const meanBlockTime = BlockCalculator.calculateAverageBlockTime(currentBlock);
    const dailyIssuance = BlockCalculator.calculateDailyIssuance(currentBlock);
    const annualInflation = BlockCalculator.calculateAnnualInflationRate(currentBlock).toFixed(4);

    return (
      <div className="stats-shell">
        <section className="stats-metrics-card">
          <h2 className="stats-card-title">Network Metrics</h2>
          <div className="stats-metrics-list">
            <div className="stats-row">
              <span className="stats-label">Bitcoin Age</span>
              <b className="stats-value">{networkAgeYears} years</b>
            </div>
            <div className="stats-row">
              <span className="stats-label">Mean Block Time</span>
              <b className="stats-value">{meanBlockTime}</b>
            </div>
            <div className="stats-row">
              <span className="stats-label">Daily Issuance</span>
              <b className="stats-value">
                <Link className="hashrate-link" to="/emission">
                  {dailyIssuance} BTC
                </Link>
              </b>
            </div>
            <div className="stats-row">
              <span className="stats-label">Annual Inflation</span>
              <b className="stats-value">
                <Link className="hashrate-link" to="/inflation">
                  {annualInflation} %
                </Link>
              </b>
            </div>
            <div className="stats-row">
              <span className="stats-label">Hashrate</span>
              <b className="stats-value">
                <Link className="hashrate-link" to="/hashrate">
                  {(hashrate / ZETTA).toFixed(2)} ZH/s
                </Link>
              </b>
            </div>
            <div className="stats-row">
              <span className="stats-label">Difficulty</span>
              <b className="stats-value">{(difficulty / TERA).toFixed(2)} T</b>
            </div>
          </div>
        </section>

        <section className="stats-gauges-grid" aria-label="Bitcoin gauges">
          <Link className="gauge-link" to="/emission">
            <EmissionGauge
              currentBlock={currentBlock}
              emittedBtc={BlockCalculator.calculateCurrentEmission(currentBlock)}
              percentage={BlockCalculator.calculateAvailableSupplyPercentage(currentBlock)}
            />
          </Link>

          <Link className="gauge-link" to="/halving">
            <CycleProgressHybrid currentBlock={currentBlock} />
          </Link>

          <Link className="gauge-link" to="/fear-greed">
            <FearAndGreedGauge
              score={score}
              avg1y={yearAverage}
              avg100d={hundredDayAverage}
            />
          </Link>
        </section>
      </div>
    );
  }

  render() {
    return (
      <ContentArea label="">
        {this.props.status
          ? this.renderStats()
          : this.renderPlaceholder()}
      </ContentArea>
    );
  }
}

export default StatsArea;
